import { Injectable } from "@angular/core";
import CryptoJS from "crypto-js";
import SecureStorage from "secure-web-storage";
import { security } from "src/environments/environment";

const SECRET_KEY = security.key;
function sha256(key) {
  key = CryptoJS.SHA256(key, SECRET_KEY);
  return key.toString();
}

function encryptKey(data) {
  data = CryptoJS.AES.encrypt(data, SECRET_KEY);
  data = data.toString();
  return data;
}

function decryptKey(data) {
  data = CryptoJS.AES.decrypt(data, SECRET_KEY);
  data = data.toString(CryptoJS.enc.Utf8);
  return data;
}

@Injectable({
  providedIn: "root",
})
export class SecureStorageService {
  constructor() {}
  public secureLocalStorage = new SecureStorage(localStorage, {
    hash: function hash(key) {
      return sha256(key);
    },
    encrypt: function encrypt(data) {
      return encryptKey(data);
    },
    decrypt: function decrypt(data) {
      return decryptKey(data);
    },
  });

  public secureSessionStorage = new SecureStorage(sessionStorage, {
    hash: function hash(key) {
      return sha256(key);
    },
    encrypt: function encrypt(data) {
      return encryptKey(data);
    },
    decrypt: function decrypt(data) {
      return decryptKey(data);
    },
  });
}
